<template>
    <div>
        <footer id="footer-web">
        </footer>
        <div class="modal-cookies" v-if="allowCookies">
            <p>Este sitio web utiliza cookies. Para obtener más información, puedes consultar nuestra Política de Cookies. Al continuar navegando aceptas la <a @click="popUpModal('cookies')" class="links">POLÍTICA DE COOKIES</a>, la <a @click="popUpModal('politics')" class="links">POLÍTICA DE PRIVACIDAD</a>, y los <a @click="popUpModal('terms')" class="links">TÉRMINOS Y CONDICIONES</a> de este sitio web.</p>
            <a class="btn-cookies" @click="allowCook">
                CERRAR
            </a>
        </div>
        <Modal v-if="showModal" v-bind:wichModal="wichModal" @close="showModal = false"/>
    </div>
</template>

<script>
import Modal from "@/components/Modal";

export default {
    name: "BannerCookies",
    data: () =>({
        allowCookies: true,
        showModal: false,
        wichModal: "terms",
    }),
    components: {
        Modal,
    },
    computed: {
    },
    created: function () {
        if (localStorage.getItem('allowCookies')) {
            const isAllowCookies = localStorage.getItem('allowCookies')
            if (isAllowCookies === 'yes') {
                this.allowCookies = false
            }
        }
    },
    methods: {
        allowCook: function() {
            this.allowCookies = false;
            localStorage.setItem('allowCookies','yes')
        },
        popUpModal(modalType) {
            this.showModal = true;
            this.wichModal = modalType;
        },
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/bannercookies.scss";
</style>